var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKofi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 4 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "matrix(1.9656019 0 0 1.9656019 0 -.0000006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.257931 8.8h1.607617c3.100776 0 5.614452 2.513676 5.614452 5.614452v.330015c0 3.100776-2.513676 5.614452-5.614452 5.614452h-1.607617v1.689795c0 1.431128-1.160158 2.591286-2.591286 2.591286h-12.2353593c-1.4311276 0-2.5912857-1.160158-2.5912857-2.591286v-11.953071c0-.7155639.5800791-1.295643 1.2956429-1.295643zm0 2.996757v5.565405h1.465573c1.536844 0 2.782703-1.245858 2.782703-2.782702 0-1.536845-1.245859-2.782703-2.782703-2.782703z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.36 5.2768458c.4002942-1.1712306 1.3489414-1.7568458 2.845941-1.7568458 2.2455 0 3.077965 2.7936503 1.900934 4.62-.784687 1.2175665-2.366979 2.757567-4.746875 4.62-2.3798961-1.862433-3.9621877-3.4024335-4.746875-4.62-1.1770309-1.8263497-.3445663-4.62 1.9009337-4.62 1.4969999 0 2.4456471.5856152 2.8459413 1.7568458z",
    fill: "#ff5e5b",
    transform: "matrix(1.9656019 0 0 1.9656019 9.513513196 17.29729612)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKofi);
export default __webpack_public_path__ + "static/media/kofi.02f7b1c6.svg";
export { ForwardRef as ReactComponent };